import { Fetcher } from '@this/src/util';

export type UpdateTripApplicationParams = {
  finalDestination?: string;
  purpose?: string;
  internalNumber?: string;
  chargingDepartmentId?: number | null;
  projectId?: number | null;
};

type UpdateTripApplicationSubmitParams = {
  final_destination?: string;
  purpose?: string;
  internal_number?: string;
  charging_department_id?: number | null;
  project_id?: number | null;
};

type TripApplicationResponse = {
  final_destination: string | null;
  purpose: string | null;
  internal_number: string | null;
  charging_departments: Array<{ id: number; name: string }>;
  projects: Array<{ id: number; name: string }>;
};

type UpdateTripApplicationResponse = {
  success: boolean;
  error?: string;
  trip?: TripApplicationResponse;
};

export type UpdatedTripApplication = {
  finalDestination: string | null;
  purpose: string | null;
  internalNumber: string | null;
  chargingDepartments: Array<{ id: number; name: string }>;
  projects: Array<{ id: number; name: string }>;
};

export type UpdateTripApplicationResult = {
  success: boolean;
  error?: string;
  trip?: UpdatedTripApplication;
};

const convertToSubmitParams = (params: UpdateTripApplicationParams): UpdateTripApplicationSubmitParams => ({
  final_destination: params.finalDestination,
  purpose: params.purpose,
  internal_number: params.internalNumber,
  charging_department_id: params.chargingDepartmentId,
  project_id: params.projectId
});

const convertResponse = (response: UpdateTripApplicationResponse): UpdateTripApplicationResult => ({
  success: response.success,
  error: response.error,
  trip: response.trip
    ? {
        finalDestination: response.trip.final_destination,
        purpose: response.trip.purpose,
        internalNumber: response.trip.internal_number,
        chargingDepartments: response.trip.charging_departments,
        projects: response.trip.projects
      }
    : undefined
});

export const updateTripApplicationInfo = async (
  tripId: string,
  params: UpdateTripApplicationParams
): Promise<UpdateTripApplicationResult> => {
  const submitParams = convertToSubmitParams(params);
  const response = await Fetcher.patch<UpdateTripApplicationResponse>(
    `/trips/${tripId}/ai_trip_application_info`,
    submitParams
  );
  return convertResponse(response);
};
